import { getCookie } from './cookieHelpers'

export default (userInfo, reason) => {
  let ANALYTICS_DATA_OBJECT = window.digitalData

  if (userInfo) {
    const loginStatus = userInfo.userState === 'GUEST' ? 'Non-Registered' : userInfo.userState === 'RECOGNISED' ? 'Recognised' : 'Registered'
    ANALYTICS_DATA_OBJECT.user[0].profile = [Object.assign({}, window.digitalData.user[0].profile, {
      profileInfo: {
        profileID: userInfo.userId
      },
      attributes: {
        loginStatus: loginStatus
      }
    })]
    ANALYTICS_DATA_OBJECT.page.pageInfo.attributes = { globalView: document.cookie.indexOf('PostCodeSessionCookie') < 0 || getCookie('PostCodeSessionCookie') === '%2C%2C' }
  }
}

export function getPageHeadAnalytics () {
  const initialDataObject = { page: { pageInfo: {}, attributes: {} } }

  initialDataObject.page.pageInfo.pageName = `ar:storelocator:landing:`
  initialDataObject.page.pageInfo.siteSection = 'ar:storelocator:'
  initialDataObject.page.attributes.platform = 'react'

  let script = `var getCookie = ${getCookie.toString()};var is_from_mcomm = document.referrer.indexOf('argos.co.uk/m/') > -1`
  let setChannelValue = `getCookie('analytics_channel') === 'mcomm' || is_from_mcomm ? 'uk:mobile' : 'uk:desktop'`
  return `${script};window.digitalData = ${JSON.stringify(initialDataObject)};digitalData.page.attributes.channel = ${setChannelValue}`
}

export function doTrack (pageName) {
  const waitForSDigitalDataAndTrack = () => {
    if (window.s === undefined) {
      // console.log(`Trying to fire '${pageName}'`)
      setTimeout(() => { waitForSDigitalDataAndTrack() }, 500)
    } else {
      // console.log(`Firing _satellite.track for event '${pageName}'`)
      window.digitalData.page.pageInfo.pageName = pageName
      window.digitalData.track('storeLocator_initialLoad')
    }
  }
  waitForSDigitalDataAndTrack()
}



// WEBPACK FOOTER //
// ./src/helpers/TaggingSerializer.js